const getRoundedNumber = (number: number, decimals?: number) => {
  if (number % 1 === 0) {
    return number.toString()
  } else {
    return number.toFixed(decimals ?? 1)
  }
}

export default getRoundedNumber
